import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IVariableDosageResponse } from 'src/app/pages/orders/interfaces/product.interface';

@Injectable({ providedIn: 'root' })
export class VariableDosageApiService {
  private headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey);

  constructor(private http: HttpClient) {}

  getVariableDosage(
    applicationCode: string,
    country: string,
    subgroup: string,
    deliveryDate: string,
    commProduct: string,
  ): Observable<IVariableDosageResponse> {
    const body = {
      applicationCode,
      country,
      subgroup,
      deliveryDate,
      commProduct,
    };
    const url = `${environment.APIM}arkik-materialmanagement/api/ProductManagement/variabledosage`;
    return this.http.post<IVariableDosageResponse>(url, body, { headers: this.headers });
  }
}
